import { h } from 'preact';
import * as actions from 'store/actions';
import * as oneTrust from 'utils/gdpr/oneTrust';

let staticRender;

staticRender = (props) => (
	<div>
		<script async src="https://www.gstatic.com/recaptcha/releases/vP4jQKq0YJFzU6e21-BGy3GP/recaptcha__en.js" crossorigin="anonymous" integrity="sha384-vs3dl3wt0sr1NSmWE/o2E71r7EDd6e3fFXEmu4tyET7uqtZw1URcwd3+DYJQtrMg" />
		<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js" defer=""></script>
		<script src="https://www.google.com/recaptcha/api.js" async="" defer=""></script>
	</div>
);

const dropCookie = new oneTrust.Pixel(
	oneTrust.FUNCTIONAL,
	(expiryDate) => {
		document.cookie = `signupBannerSeen=true; expires=${expiryDate.toUTCString()}`;
	},
	true
).createTrigger();

let storeListeners = {};

storeListeners[actions.DROP_SIGNUP_COOKIE] = (expiryDate) => {
	dropCookie(expiryDate);
};

export {
	staticRender,
	storeListeners
};
